import { EnhancedQuestion, UserAnswer } from "../../types/questionFormats";
import { EnhancedScoringService } from "../services/enhancedScoringService";

export type StoredSinglePlayerAnswer = string | number[] | Record<string, string>;

export type SinglePlayerQuestion = Partial<EnhancedQuestion> & {
  answer?: string;
  correct_answer?: string;
};

export type SinglePlayerAnswerOutcome = {
  score: number;
  isCorrect: boolean;
};

export function normalizeStoredSinglePlayerAnswer(
  answer: string | UserAnswer,
): StoredSinglePlayerAnswer {
  if (typeof answer === "string") {
    return answer;
  }

  switch (answer.format) {
    case "mcq_multiple":
      return answer.answers;
    case "true_false":
      return answer.answer.toString();
    case "fill_blank":
      return answer.answers;
    case "ordering":
      return answer.order;
    case "mcq_single":
      return answer.answer;
    default:
      return String(answer);
  }
}

export function scoreSinglePlayerAnswer(
  question: SinglePlayerQuestion,
  answer: string | UserAnswer,
): number {
  return evaluateSinglePlayerAnswer(question, answer).score;
}

export function evaluateSinglePlayerAnswer(
  question: SinglePlayerQuestion,
  answer: string | UserAnswer,
): SinglePlayerAnswerOutcome {
  if (typeof answer === "string") {
    const correct = question?.answer || question?.correct_answer;
    const isCorrect = answer === correct;
    return {
      score: isCorrect ? 1 : 0,
      isCorrect,
    };
  }

  if (answer.format === "true_false") {
    const correctAnswer = question?.format_data?.correct_answer;
    const isCorrect = answer.answer === correctAnswer;
    return {
      score: isCorrect ? 1 : 0,
      isCorrect,
    };
  }

  const result = EnhancedScoringService.calculateQuestionScore(
    question as EnhancedQuestion,
    answer,
    30,
  );
  return {
    score: result.score,
    isCorrect: result.percentage === 100,
  };
}
